import {Component} from '@angular/core';
import {AuthService} from "../auth/auth.service";

@Component({
    selector: 'db-something-went-wrong',
    templateUrl: './something-went-wrong.component.html',
    styleUrls: ['./something-went-wrong.component.scss'],
    standalone: false
})
export class SomethingWentWrongComponent {
  public loading: boolean;

  constructor(
    private _authService: AuthService
  ) {}

  public logout(): void {
    if (this._authService.canLogout()) {
      if (typeof window['zE'] !== 'undefined') {
        window['zE']('messenger', 'logoutUser');
      }
      if (typeof window['Smooch'] !== 'undefined') {
        window['Smooch']?.logout();
      }      this.loading = true;
      this._authService.logoutFromProfile();
    }
  }
}
